// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3h_xW","icon":"SortAdornment_icon__1duxx","up":"SortAdornment_up__Tu9TN","down":"SortAdornment_down__1gI42","active":"SortAdornment_active__2NckO"};